import { lazy } from 'react'

export const BonusEmptyIcon = lazy(() => import('./BonusEmptyIcon'))
export const BonusIcon = lazy(() => import('./BonusIcon'))
export const RewardCashBonusIcon = lazy(() => import('./RewardCashBonusIcon'))
export const RewardFreeTicketIcon = lazy(() => import('./RewardFreeTicketIcon'))
export const RewardFreeBetIcon = lazy(() => import('./RewardFreeBetIcon'))
export const RewardFirstDepositIcon = lazy(() => import('./RewardFirstDepositIcon'))
export const RewardMerchIcon = lazy(() => import('./RewardMerchIcon'))
export const RewardFreeSpinIcon = lazy(() => import('./RewardFreeSpinIcon'))
export const RewardFreeSubscriptionsIcon = lazy(() => import('./RewardFreeSubscriptionsIcon'))
export const RewardOtherIcon = lazy(() => import('./RewardOtherIcon'))
export const FolderSettingsIcon = lazy(() => import('./FolderSettingsIcon'))
export const TeamIcon =  lazy(() => import('./TeamIcon'))
export const ShareIOSSafariIcon =  lazy(() => import('./ShareIOSSafariIcon'))
export const ShareIOSSafariModernIcon =  lazy(() => import('./ShareIOSSafariModernIcon'))
export const HomeScreenIOSSafariIcon =  lazy(() => import('./HomeScreenIOSSafariIcon'))
export const HomeScreenIOSSafariModernIcon =  lazy(() => import('./HomeScreenIOSSafariModernIcon'))
export const TrashBinIcon =  lazy(() => import('./TrashBinIcon'))
export const PinIcon =  lazy(() => import('./PinIcon'))
export const AddCircleOutlineIcon =  lazy(() => import('./AddCircleOutlineIcon'))
export const BrandIcon =  lazy(() => import('./BrandIcon'))
export const CirclesIcon =  lazy(() => import('./CirclesIcon'))
export const WalletIcon =  lazy(() => import('./WalletIcon'))
export const CircleCrossIcon =  lazy(() => import('./CircleCrossIcon'))
export const CircleVoidIcon = lazy(() => import('./CircleVoidIcon'))
export const ThreeDotsIcon =  lazy(() => import('./ThreeDotsIcon'))
export const SpinIcon =  lazy(() => import('./SpinIcon'))
export const WinRate =  lazy(() => import('./WinRate'))
export const Spiral =  lazy(() => import('./Spiral'))
export const VoteBettingFadedIcon =  lazy(() => import('./VoteBettingFaded'))
export const EventsIcon =  lazy(() => import('./EventsIcon'))
export const ElipseArrowIcon =  lazy(() => import('./EventsIcon'))
export const BrushIcon =  lazy(() => import('./BrushIcon'))
export const BackIcon =  lazy(() => import('./BackIcon'))
export const FilterIcon =  lazy(() => import('./FilterIcon'))
export const AttachIcon =  lazy(() => import('./AttachIcon'))
export const PostIcon =  lazy(() => import('./PostIcon'))
export const PostTipIcon =  lazy(() => import('./PostTipIcon'))
export const StatisticIcon =  lazy(() => import('./Statistics'))
export const EmojiIcon =  lazy(() => import('./EmojiIcon'))
export const FavouriteIcon =  lazy(() => import('./FavouriteIcon'))
export const InformationOutlineIcon =  lazy(() => import('./InformationOutlineIcon'))
export const CaretDownIcon =  lazy(() => import('./CaretDownIcon'))
export const FirstPlace =  lazy(() => import('./FirstPlace'))
export const SecondPlace =  lazy(() => import('./SecondPlace'))
export const ThirdPlace =  lazy(() => import('./ThirdPlace'))
export const CaretUpIcon =  lazy(() => import('./CaretUpIcon'))
export const InfoOutlineIcon =  lazy(() => import('./InfoOutline'))
export const LinkIcon =  lazy(() => import('./Link'))
export const NewIcon =  lazy(() => import('./New'))
export const FeaturedIcon =  lazy(() => import('./Featured'))
export const HotIcon =  lazy(() => import('./Hot'))
export const MostProfitIcon =  lazy(() => import('./MostProfit'))
export const TopFootballIcon =  lazy(() => import('./TopFootball'))
export const TopTennisIcon =  lazy(() => import('./TopTennis'))
export const TrendIcon =  lazy(() => import('./Trend'))
export const LeaderboardIcon =  lazy(() => import('./LeaderboardIcon'))
export const AngleLeftIcon =  lazy(() => import('./AngleLeftIcon'))
export const AngleRightIcon =  lazy(() => import('./AngleRightIcon'))
export const TwitterIcon =  lazy(() => import('./TwitterIcon'))
export const ViberIcon =  lazy(() => import('./ViberIcon'))
export const CopyIcon =  lazy(() => import('./CopyIcon'))
export const PersonCircleOutlineIcon =  lazy(() => import('./PersonCircleOutlineIcon'))
export const InfoIcon =  lazy(() => import('./InfoIcon'))
export const CommentIcon =  lazy(() => import('./CommentIcon'))
export const PollIcon =  lazy(() => import('./PollIcon'))
export const ClockIcon =  lazy(() => import('./ClockIcon'))
export const TelegramIcon =  lazy(() => import('./TelegramIcon'))
export const WhatsAppIcon =  lazy(() => import('./WhatsAppIcon'))
export const ThinMinusIcon =  lazy(() => import('./ThinMinusIcon'))
export const UpvoteIcon =  lazy(() => import('./UpvoteIcon'))
export const DownvoteIcon =  lazy(() => import('./DownvoteIcon'))
export const UpvoteFilledIcon =  lazy(() => import('./UpvoteFilledIcon'))
export const DownvoteFilledIcon =  lazy(() => import('./DownvoteFilledIcon'))
export const ShareIcon =  lazy(() => import('./ShareIcon'))
export const LockIcon =  lazy(() => import('./LockIcon'))
export const CrownIcon =  lazy(() => import('./CrownIcon'))
export const CrownFilledIcon =  lazy(() => import('./CrownFilledIcon'))
export const LogoutIcon =  lazy(() => import('./LogoutIcon'))
export const LogoutLineIcon =  lazy(() => import('./LogoutLineIcon'))
export const DragIcon =  lazy(() => import('./DragIcon'))
export const Dots2x3Icon =  lazy(() => import('./Dots2x3Icon'))
export const ThinPlusIcon =  lazy(() => import('./ThinPlusIcon'))
export const CalendarIcon =  lazy(() => import('./CalendarIcon'))
export const MenuIcon =  lazy(() => import('./MenuIcon'))
export const NewspaperIcon =  lazy(() => import('./NewspaperIcon'))
export const GearIcon =  lazy(() => import('./GearIcon'))
export const StarIcon =  lazy(() => import('./StarIcon'))
export const LetterIcon =  lazy(() => import('./LetterIcon'))
export const ProfileIcon =  lazy(() => import('./ProfileIcon'))
export const BookmarksIcon =  lazy(() => import('./BookmarksIcon'))
export const BellIcon =  lazy(() => import('./BellIcon'))
export const GoogleIcon =  lazy(() => import('./GoogleIcon'))
export const CheckmarkIcon =  lazy(() => import('./CheckmarkIcon'))
export const CloseIcon =  lazy(() => import('./CloseIcon'))
export const PlusIcon =  lazy(() => import('./PlusIcon'))
export const TicketIcon =  lazy(() => import('./TicketIcon'))
export const EditIcon =  lazy(() => import('./EditIcon'))
export const VoteIcon =  lazy(() => import('./VoteIcon'))
export const ArrowRightIcon =  lazy(() => import('./ArrowRightIcon'))
export const CheckboxUncheckedIcon =  lazy(() => import('./CheckboxUncheckedIcon'))
export const CircleCheckIcon =  lazy(() => import('./CircleCheckIcon'))
export const CancelCircleIcon =  lazy(() => import('./CancelCircleIcon'))
export const EighteenPlusIcon =  lazy(() => import('./EighteenPlusIcon'))
export const HomeIcon =  lazy(() => import('./HomeIcon'))
export const MagnifyingGlassIcon =  lazy(() => import('./MagnifyingGlassIcon'))
export const AngleDownIcon =  lazy(() => import('./AngleDownIcon'))
export const AlertTriangleIcon =  lazy(() => import('./AlertTriangleIcon'))
export const ArrowLeftIcon =  lazy(() => import('./ArrowLeftIcon'))
export const FacebookIcon =  lazy(() => import('./FacebookIcon'))
export const RadioButtonIcon =  lazy(() => import('./RadioButtonIcon'))
export const CircleIcon =  lazy(() => import('./CircleIcon'))
export const CheckboxCheckedIcon =  lazy(() => import('./CheckboxCheckedIcon'))
export const InstagramIcon =  lazy(() => import('./InstagramIcon'))
export const DownloadIcon =  lazy(() => import('./DownloadIcon'))
export const RedirectIcon =  lazy(() => import('./RedirectIcon'))
export const SocialMediaKitIcon =  lazy(() => import('./SocialMediaKit'))
export const TelegramKitIcon =  lazy(() => import('./TelegramKitIcon'))
export const AiIcon =  lazy(() => import('./AiIcon'))
export const ChannelStar =  lazy(() => import('./ChannelStar'))
export const EditPencileIcon =  lazy(() => import('./EditPencileIcon'))
export const AddImageIcon =  lazy(() => import('./AddImageIcon'))
export const DocumentIcon =  lazy(() => import('./DocumentIcon'))
export { EarthOutlineIcon } from './EarthIcon'
export const AppInviteIcon =  lazy(() => import('./appInvite'))
export const MicroPhoneMutedIcon =  lazy(() => import('./MicrophoneMuted'))
// SPORT ICONS
export const FootballIcon =  lazy(() => import('./FootballIcon'))
export const FrameIcon =  lazy(() => import('./FrameIcon'))
export const TennisIcon =  lazy(() => import('./TennisIcon'))
export const GolfIcon =  lazy(() => import('./GolfIcon'))
export const CyclingIcon =  lazy(() => import('./CyclingIcon'))
export const ESportsIcon =  lazy(() => import('./ESportsIcon'))
export const RugbyIcon =  lazy(() => import('./RugbyIcon'))
export const CricketIcon =  lazy(() => import('./CricketIcon'))
export const BasketballIcon =  lazy(() => import('./BasketballIcon'))
export const BaseballIcon =  lazy(() => import('./BaseballIcon'))
export const AmericanFootballIcon =  lazy(() => import('./AmericanFootballIcon'))
export const HockeyIcon =  lazy(() => import('./HockeyIcon'))
export const VolleyballIcon =  lazy(() => import('./VolleyballIcon'))
export const HandballIcon =  lazy(() => import('./HandballIcon'))
export const RugbyLeagueIcon =  lazy(() => import('./RugbyLeagueIcon'))
export const BoxingIcon =  lazy(() => import('./BoxingIcon'))
export const MMAIcon =  lazy(() => import('./MMAIcon'))
export const TableTennisIcon =  lazy(() => import('./TableTennisIcon'))
export const TandC =  lazy(() => import('./TermsAndConditions'))
export const Delete =  lazy(() => import('./DeleteIcon'))
export const Warning =  lazy(() => import('./Warning'))
export const Upload =  lazy(() => import('./UploadIcon'))
export const AddImage =  lazy(() => import('./AddImageIcon'))
export const AddGif =  lazy(() => import('./AddGifIcon'))
export const IosInstall =  lazy(() => import('./IosInstallIcon'))
export const IosShareIcon =  lazy(() => import('./IosShareIcon'))
export const DownloadArrow =  lazy(() => import('./DownloadArrow'))
export const StarLineIcon =  lazy(() => import('./StarLineIcon'))
export const ShareLineIcon =  lazy(() => import('./ShareLineIcon'))
export const AddUserLineIcon =  lazy(() => import('./AddUserLineIcon'))
export const AngleTopIcon =  lazy(() => import('./AngleTopIcon'))
export const AngledownLineIcon =  lazy(() => import('./AngledownLineIcon'))
export const GlassesIcon =  lazy(() => import('./GlassesIcon'))
export const MailIcon =  lazy(() => import('./MailIcon'))
export const SavedTipIcon =  lazy(() => import('./SavedTipIcon'))
export const UserCheckIcon =  lazy(() => import('./UserCheckIcon'))
export const SubscriberListIcon =  lazy(() => import('./SubscriberListIcon'))
export const NotificationIcon =  lazy(() => import('./NotificationIcon'))
export const WorldIcon =  lazy(() => import('./WorldIcon'))
export const ShareIconUpdate =  lazy(() => import('./ShareIconUpdate'))
export const ShareArrowIcon = lazy(() => import('./ShareArrowIcon'))
export const MatchesVotedIcon =  lazy(() => import('./MatchesVotedIcon'))
export const TrashBinLineIcon =  lazy(() => import('./TrashBinLineIcon'))
export const ShareFIlledIcon =  lazy(() => import('./ShareFilledIcon'))
export const LockLineIcon =  lazy(() => import('./LockLineIcon'))
export const PlusLineIcon =  lazy(() => import('./PlusLineIcon'))
export const NotificationLineIcon =  lazy(() => import('./NotificationLineIcon'))
export const CalendarLineIcon =  lazy(() => import('./CalendarLineIcon'))
export const StarLineIconFilled =  lazy(() => import('./StarLineIconFilled'))
export const MenuHorizontalIcon =  lazy(() => import('./MenuHorizontalIcon'))
export const TimeDivider =  lazy(() => import('./TimeDivider'))
export const InfoCircledIcon =  lazy(() => import('./InfoCircledIcon'))
export const UserPlusIcon =  lazy(() => import('./UserPlusIcon'))
export const DownvoteBoldIcon =  lazy(() => import('./DownvoteBoldIcon'))
export const UpvoteBoldIcon =  lazy(() => import('./UpvoteBoldIcon'))
export const ShareLineBoldIcon =  lazy(() => import('./ShareLineBoldIcon'))
export const CommentBoldIcon =  lazy(() => import('./CommentBoldIcon'))
export const HomeLineIcon =  lazy(() => import('./HomeLineIcon'))
export const ChannelLineIcon =  lazy(() => import('./ChannelLineIcon'))
export const VotingLineIcon =  lazy(() => import('./VotingLineIcon'))
export const VipIcon =  lazy(() => import('./VipIcon'))
export const FreeIcon =  lazy(() => import('./FreeIcon'))
export const FreeBrandIcon =  lazy(() => import('./FreeBrandIcon'))
export const VipBrandIcon =  lazy(() => import('./VipBrandIcon'))
export const TipWonIcon =  lazy(() => import('./TipWonIcon'))
export const TipLostIcon =  lazy(() => import('./TipLostIcon'))
export const MenuLineIcon =  lazy(() => import('./MenuLineIcon'))
export const TipIcon =  lazy(() => import('./TipIcon'))
export const PollLineIcon =  lazy(() => import('./PollLineIcon'))
export const MarkIcon =  lazy(() => import('./MarkIcon'))
export const CloseLineIcon =  lazy(() => import('./CloseLineIcon'))
export const CloseMenuIcon =  lazy(() => import('./CloseMenuIcon'))
export const SendIcon =  lazy(() => import('./SendIcon'))
export const CrossedLockIcon =  lazy(() => import('./CrossedLockIcon'))
export const AngleDownBoldIcon =  lazy(() => import('./AngleDownBoldIcon'))
export const TotalTipChartIcon =  lazy(() => import('./TotalTipChartIcon'))
export const WinRateChartIcon =  lazy(() => import('./WinRateChartIcon'))
export const UploadArrowIcon =  lazy(() => import('./UploadArrowIcon'))
export const ImageUploadBackdrop =  lazy(() => import('./ImageUploadBackdrop'))
export const AddIcon =  lazy(() => import('./AddIcon'))
export const CloseBigIcon =  lazy(() => import('./CloseBigIcon'))
export const DeleteLineIcon =  lazy(() => import('./DeleteLineIcon'))
export const EditImageIcon =  lazy(() => import('./EditImageIcon'))
export const MultipleChannelIcon =  lazy(() => import('./MultipleChannelIcon'))
export const CircleCheckWithBorder =  lazy(() => import('./CircleCheckWithBorder'))
export const SearchIcon =  lazy(() => import('./SearchIcon'))
export const PaymentHeader =  lazy(() => import('./PaymentHeader'))
export const DollarIcon =  lazy(() => import('./DollarIcon'))
export const PercentageIcon =  lazy(() => import('./PercentageIcon'))
export const CommentLineIcon =  lazy(() => import('./CommentLineIcon'))
export const DividerIcon =  lazy(() => import('./DividerIcon'))
export const AngleUpIcon =  lazy(() => import('./AngleUpIcon'))
export const AngleDownThinIcon =  lazy(() => import('./AngleDownThinIcon'))
export const FootballHeader =  lazy(() => import('./FootballHeader'))
export const MagicLinkIcon =  lazy(() => import('./MagicLinkIcon'))
export const WaterMarkIcon =  lazy(() => import('./WaterMarkIcon'))
export const ServiceIcon =  lazy(() => import('./ServiceIcon'))
export const MagicLinkRingIcon =  lazy(() => import('./MagicLinkRingIcon'))
export const DangerIcon =  lazy(() => import('./DangerIcon'))
export const ArrowFullIcon =  lazy(() => import('./ArrowFull'))
export const HomeRefreshedIcon =  lazy(() => import('./HomeRefreshedIcon'))
export const ChannelIcon =  lazy(() => import('./ChannelIcon'))
export const VoteRefreshedIcon =  lazy(() => import('./VoteRefreshedIcon'))
export const HambugerIcon =  lazy(() => import('./HambugerIcon'))
export const MessageIcon =  lazy(() => import('./MessageIcon'))
export const ScoreLineIcon =  lazy(() => import('./ScoreLineIcon'))
export const SubscriptionIcon =  lazy(() => import('./SubscriptionIcon'))
export const TelegramBotIcon =  lazy(() => import('./TelegramBotIcon'))
export const ChannelInviteIcon =  lazy(() => import('./ChannelInviteIcon'))
export const SupportIcon =  lazy(() => import('./SupportIcon'))
export const LiveChatIcon = lazy(() => import('./LiveChatIcon'))
export const SendMessageIcon = lazy(() => import('./SendMessageIcon'))
export const TicketStarIcon =  lazy(() => import('./TicketStarIcon'))
export const WriteIcon =  lazy(() => import('./WriteIcon'))
export const TaskSquareIcon =  lazy(() => import('./TaskSquareIcon'))
export const EnvelopeIcon =  lazy(() => import('./EnvelopeIcon'))
export const CaretRightIcon =  lazy(() => import('./CaretRightIcon'))
export const BookIcon =  lazy(() => import('./BookIcon'))
export const StarsIcon =  lazy(() => import('./Stars'))
export const QuestionSquareIcon =  lazy(() => import('./QuestionSquareIcon'))
export const DeviceMessageIcon =  lazy(() => import('./DeviceMessageIcon'))
export const CompetitionsFootbalIcon =  lazy(() => import('./CompetitionsFootball'))
export const FirstCompetitionPlace =  lazy(() => import('./FirstPosition'))
export const SecondCompetitionPlace =  lazy(() => import('./SecondPosition'))
export const ThirdCompetitionPlace =  lazy(() => import('./ThirdPosition'))
export const PlayIcon =  lazy(() => import('./PlayIcon'))
export const PauseIcon =  lazy(() => import('./PauseIcon'))
export const StopIcon =  lazy(() => import('./StopIcon'))
export const StreamIcon =  lazy(() => import('./StreamIcon'))
export const LiveStreamIcon = lazy(() => import('./LiveStreamIcon'))
export const HeadphonesIcon =  lazy(() => import('./HeadphonesIcon'))
export const ChartIcon =  lazy(() => import('./ChartIcon'))
export const TelegramSocialIcon =  lazy(() => import('./TelegramSocialIcon'))
export const XIcon =  lazy(() => import('./XIcon'))
export const InstagramSocialIcon =  lazy(() => import('./InstagramSocialIcon'))
export const LinkedInIcon =  lazy(() => import('./LinkedInIcon'))
export const InternetIcon =  lazy(() => import('./InternetIcon'))
export const RingsIcon =  lazy(() => import('./RingsIcon'))
export const MediaImageIcon =  lazy(() => import('./MediaImageIcon'))
export const VoiceIcon =  lazy(() => import('./VoiceIcon'))
export const GifFormatIcon =  lazy(() => import('./GifFormatIcon'))
export const VideoCameraIcon =  lazy(() => import('./VideoCameraIcon'))
export const MicrophoneIcon =  lazy(() => import('./MicrophoneIcon'))
export const RecordIcon =  lazy(() => import('./RecordIcon'))
export const SubscriptionPlanIcon = lazy(() => import('./SubscriptionPlanIcon'))
export const LoadingIcon = lazy(() => import('./LoadingIcon'))
export const ChangeRolesIcon =  lazy(() => import('./ChangeRolesIcon'))
